import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class SurveyLinkElement extends SurveyElement {
  @Expose({ name: 'text' })
  label!: string | null;

  @Expose()
  type!: number;

  @Expose({ name: 'url' })
  to!: string;
}
